import { useEffect, useState } from "react";

import { type WebLensBuildOutputMeasurement, measureWebLensBuildOutput } from "../utils/measureWebLensBuildOutput";

/**
 * Measures the picked package's build output for the lens-budget gate. The dropzone's meter, the
 * rail's budget row, the submit/update buttons and runClientPreChecks all read this one value, so
 * they can never disagree about the same file. Null while nothing is picked, while the parse is
 * in flight, and for archives the parser bails on — in every null case the gate stays open and
 * the server-side conversion is the verdict.
 */
export const useWebLensBuildOutputMeasurement = (file: File | null): WebLensBuildOutputMeasurement | null => {
    const [measurement, setMeasurement] = useState<WebLensBuildOutputMeasurement | null>(null);

    useEffect(() => {
        setMeasurement(null);
        if (!file) {
            return;
        }
        let stale = false;
        void measureWebLensBuildOutput(file).then((measured) => {
            if (!stale) {
                setMeasurement(measured);
            }
        });
        return () => {
            stale = true;
        };
    }, [file]);

    return measurement;
};
